import facturaElectronica from '../../../../menu/cl/facturaElectronica';
import edSettings from '../../../../menu/cl/ed/edSettings';
import compras from '../../../../menu/cl/compras';
import configuracion from '../../../../menu/cl/configuracion';
import contratos from '../../../../menu/cl/contratos';
import gestionDocumentos from '../../../../menu/cl/ed/documentManagement';
import supportEd from '../../../../menu/cl/ed/supportEd';
import gastos from '../../../../menu/cl/gastos';
import partners from '../../../../menu/cl/partners';
import aduanas from '../../../../menu/cl/aduanas/aduanas';

import aduanasSettings from '@/menu/cl/aduanas/aduanasSettings';
import approvalsMobile from '@/menu/cl/ed/approvalsMobile';
import allMenus from '@/menu/cl/ed/allMenus';
import materialsRequests from '@/menu/cl/materialsRequests';
import billing from '@/menu/cl/billing';

export default {
  async seleccionarModulo({ commit, rootGetters }, modulo) {
    commit('SET_MODULO_ACTUAL', modulo);
    // eslint-disable-next-line default-case
    switch (modulo) {
      case 'edSettings':
        // eslint-disable-next-line
        const isMop = rootGetters['Empresas/iut'] === '61202000-0';
        /* si la empresa no es el mop, se cambiarn los
        nombres de los mantenedores de manera visual */
        // eslint-disable-next-line
        const regionObj = edSettings
          .find((m) => m).items
          .find((i) => i.name === 'Mantenedores').submenu
          .find((i) => i.url.name === 'maintainer-regions');
        regionObj.name = isMop ? 'Regiones' : 'Categorias';
        regionObj.i18n = isMop ? 'Regiones' : 'Categorias';
        // eslint-disable-next-line
        const servicioObj = edSettings
          .find((m) => m).items
          .find((i) => i.name === 'Mantenedores').submenu
          .find((i) => i.url.name === 'maintainer-services');
        servicioObj.name = isMop ? 'Servicios' : 'Subcategorias';
        servicioObj.i18n = isMop ? 'Servicios' : 'Subcategorias';
        commit('SET_MENU', edSettings); break;
      case 'facturaElectronica': commit('SET_MENU', facturaElectronica); break;
      case 'approvals': commit('SET_MENU', allMenus); break;
      case 'expedientesEd': commit('SET_MENU', allMenus); break;
      case 'compras': commit('SET_MENU', compras); break;
      case 'gastos': commit('SET_MENU', gastos); break;
      case 'configuracion': commit('SET_MENU', configuracion); break;
      case 'contratos': commit('SET_MENU', contratos); break;
      case 'partners': commit('SET_MENU', partners); break;
      case 'escritorioDigital': commit('SET_MENU', allMenus); break;
      case 'gestionDocumentos': commit('SET_MENU', gestionDocumentos); break;
      case 'officesManagement': commit('SET_MENU', allMenus); break;
      case 'internOfficesManagement': commit('SET_MENU', allMenus); break;
      case 'supportEd': commit('SET_MENU', supportEd); break;
      case 'approvalsMobileApp': commit('SET_MENU', approvalsMobile); break;
      case 'aduanas': commit('SET_MENU', aduanas); break;
      case 'aduanasSettings': commit('SET_MENU', aduanasSettings); break;
      case 'materialRequests': commit('SET_MENU', materialsRequests); break;
      case 'billing': commit('SET_MENU', billing); break;
    }
  }
};
